import { BrowserModule } from '@angular/platform-browser';
import { NgModule, OnInit } from '@angular/core';
import { AngularFireModule } from 'angularfire2';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { AngularFireAuthModule, AngularFireAuth } from 'angularfire2/auth';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { RouterModule, Routes, Router } from '@angular/router';
import { LoginModule } from '../app/login/login.module';
import { LoginComponent } from './login/login.component';
import { MainModule } from './main/main.module';
import { MainComponent } from './main/main.component';
import { FakturPajakKeluaranModule } from './faktur-pajak-keluaran/faktur-pajak-keluaran.module';
import { FakturPajakKeluaranComponent } from './faktur-pajak-keluaran/faktur-pajak-keluaran.component';
import { FakturPajakMasukanModule } from './faktur-pajak-masukan/faktur-pajak-masukan.module';
import { StringShufflerPipe } from './string-shuffler.pipe';
import {MatDialogModule} from '@angular/material';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { FakturPajakMasukanComponent } from './faktur-pajak-masukan/faktur-pajak-masukan.component';
import { HomeGridComponent } from './main/home-grid/home-grid.component';
import { FaqComponent } from './faq/faq.component';
import { PrivacyStatementComponent } from './privacy-statement/privacy-statement.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
const appRoutes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'app', component: MainComponent,
    children: [
      { path: 'home', component: HomeGridComponent},
      { path: 'fk', component: UnderConstructionComponent },
      { path: 'fm', component: FakturPajakMasukanComponent},
      { path: 'faq', component: FaqComponent},
      { path: 'privacy', component: PrivacyStatementComponent},
      { path: 'mobile_scanner', component: UnderConstructionComponent},
      { path: 'about', component: UnderConstructionComponent},
      { path: 'eula', component: UnderConstructionComponent}

    ]
  }
];

@NgModule({
  declarations: [
    AppComponent,
    StringShufflerPipe
  ],
  imports: [
    BrowserModule,
    LoginModule,
    MainModule,
    FakturPajakKeluaranModule,
    FakturPajakMasukanModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    RouterModule.forRoot(appRoutes, {enableTracing: true}),
  ],
  providers: [StringShufflerPipe, AngularFireModule, AngularFireAuthModule, AngularFirestoreModule, AngularFireStorageModule],
  exports: [],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public fauth: AngularFireAuth, public router: Router) {
    this.fauth.authState.subscribe(res => {
      if (res && res.uid) {
        this.router.navigateByUrl('/app/home');
      } else {
        this.router.navigateByUrl('/login');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts